import { PartialEarlySettlementError } from '../types';

export const defaultPartialEarlySettlementError: PartialEarlySettlementError = {
    settlementDate: {
        required: 'Please enter a date.',
        valid: 'Please enter a valid date.',
        min: 'You can only enter dates starting today.',
    },
};
